import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-pv-power-learn-more-modal',
  templateUrl: './pv-power-learn-more-modal.component.html',
  styleUrls: ['./pv-power-learn-more-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PvPowerLearnMoreModalComponent {
  constructor(public dialogRef: MatDialogRef<PvPowerLearnMoreModalComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
